import { useEffect, useState } from "react";
import { AuthService } from "../../services/AuthService";
import { Button, Spin, Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Title from "antd/es/typography/Title";


const columns = [
    {
        title: 'Emri',
        dataIndex: 'fullName',
        key: 'fullName',
    },
    {
        title: 'Emaili',
        dataIndex: 'userName',
        key: 'userName',
    },
    {
        title: 'Roli',
        dataIndex: 'roleName',
        key: 'roleName',
    },
    {
        title: "Pika shitëse",
        dataIndex: 'assignedStore',
        key: 'assignedStore'
    },
    // {
    //     title: 'ACTIONS',
    //     dataIndex: 'actions',
    //     key: 'actions',
    //     render: (text, record) => (
    //         <>
    //             <button onClick={() => console.log(record)}>Edit</button>
    //             <button onClick={() => console.log(record)}>Delete</button>
    //         </>
    //     )
    // }

]
const Users = () => {

    const navigate = useNavigate();
    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(false);


    const getAllUsers = async () => {
        setLoading(true);
        let res = await AuthService.getAllUsers({});
        if (res) {
           
            setUsers(res);
        }
        console.log("get all users", res);
        setLoading(false);
    }

    const handleRowClick = (record) => {
        navigate("/users/new", { state: { user: record } });

    };

    useEffect(() => {
        getAllUsers();
    }, [])
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Përdoruesit</Title>
                <Link to="/users/new" style={{ display: "flex" }}>
                    <Button type="primary">Shto një të ri</Button>
                </Link>
            </div>
            <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={users} size="small" columns={columns} onRow={(record) => ({
                onClick: () => {
                    handleRowClick(record);
                },
            })} style={{ width: "100%", marginTop: 20 }} /></Spin>

        </>
    )
}

export default Users;